import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Agencies from './pages/Agencies';
import AgencyView from './pages/AgencyView';
import AgencyForm from './pages/AgencyForm';
import VisaManagement from './pages/VisaManagement';
import CountryImages from './pages/CountryImages';
import Updates from './pages/Updates';
import VisaApplications from './pages/VisaApplications';
import RAGDocuments from './pages/RAGDocuments';
import BusinessRegistrations from './pages/BusinessRegistrations';
import BusinessSettings from './pages/BusinessSettings';
import InviteCodes from './pages/InviteCodes';
import Feedback from './pages/Feedback';
import Users from './pages/Users';
import Activity from './pages/Activity';
import CreateCompany from './pages/CreateCompany';
import Perks from './pages/Perks';
import Partners from './pages/Partners';
import Tasks from './pages/Tasks';
import Vendors from './pages/Vendors';
import VendorForm from './pages/VendorForm';
import DiscountCodes from './pages/DiscountCodes';
import DiscountCodeForm from './pages/DiscountCodeForm';
import NaytiveApplications from './pages/NaytiveApplications';
import NaytiveInbox from './pages/NaytiveInbox';
import NaytiveBankingWaitlist from './pages/NaytiveBankingWaitlist';
import NaytiveBankingAccess from './pages/NaytiveBankingAccess';
import NaytiveLandingLeads from './pages/NaytiveLandingLeads';
import NaytiveBlog from './pages/NaytiveBlog';
import NaytiveCareers from './pages/NaytiveCareers';
import NaytiveIncorporation from './pages/NaytiveIncorporation';
import NaytiveCompliance from './pages/NaytiveCompliance';
import Deals from './pages/Deals';
import NaytiveProposals from './pages/NaytiveProposals';
import FilingTemplates from './pages/FilingTemplates';
import VoicePicker from './pages/VoicePicker';
import NaytiveApplicationDetail from './pages/NaytiveApplicationDetail';
import PersonaSkills from './pages/PersonaSkills';
import VisaCriteria from './pages/VisaCriteria';
import CompliancePro from './pages/CompliancePro';
import NaytiveFlags from './pages/NaytiveFlags';
import NaytivePush from './pages/NaytivePush';
import NaytiveChats from './pages/NaytiveChats';
import IntelligenceKb from './pages/IntelligenceKb';
import IntelligenceKbDraft from './pages/IntelligenceKbDraft';
import IntelligenceKbRules from './pages/IntelligenceKbRules';
import IntelligenceKbRecord from './pages/IntelligenceKbRecord';
import IntelligenceConcierge from './pages/IntelligenceConcierge';
import IntelligenceConciergeTurn from './pages/IntelligenceConciergeTurn';
import './styles/global.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes - redirect to dashboard if logged in */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          {/* Protected routes - redirect to login if not logged in */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agencies"
            element={
              <ProtectedRoute>
                <Agencies />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agencies/new"
            element={
              <ProtectedRoute>
                <AgencyForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agencies/:id"
            element={
              <ProtectedRoute>
                <AgencyView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agencies/:id/edit"
            element={
              <ProtectedRoute>
                <AgencyForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/visa-management"
            element={
              <ProtectedRoute>
                <VisaManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/visa-applications"
            element={
              <ProtectedRoute>
                <VisaApplications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/country-images"
            element={
              <ProtectedRoute>
                <CountryImages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/updates"
            element={
              <ProtectedRoute>
                <Updates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rag-documents"
            element={
              <ProtectedRoute>
                <RAGDocuments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/business-registrations"
            element={
              <ProtectedRoute>
                <BusinessRegistrations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/business-settings"
            element={
              <ProtectedRoute>
                <BusinessSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invite-codes"
            element={
              <ProtectedRoute>
                <InviteCodes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/feedback"
            element={
              <ProtectedRoute>
                <Feedback />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/activity"
            element={
              <ProtectedRoute>
                <Activity />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create-company"
            element={
              <ProtectedRoute>
                <CreateCompany />
              </ProtectedRoute>
            }
          />
          <Route
            path="/perks"
            element={
              <ProtectedRoute>
                <Perks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partners"
            element={
              <ProtectedRoute>
                <Partners />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tasks"
            element={
              <ProtectedRoute>
                <Tasks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/persona-skills"
            element={
              <ProtectedRoute>
                <PersonaSkills />
              </ProtectedRoute>
            }
          />
          <Route
            path="/visa-criteria"
            element={
              <ProtectedRoute>
                <VisaCriteria />
              </ProtectedRoute>
            }
          />
          <Route
            path="/compliance-pro"
            element={
              <ProtectedRoute>
                <CompliancePro />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-push"
            element={
              <ProtectedRoute>
                <NaytivePush />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-flags"
            element={
              <ProtectedRoute>
                <NaytiveFlags />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-chats"
            element={
              <ProtectedRoute>
                <NaytiveChats />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendors"
            element={
              <ProtectedRoute>
                <Vendors />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendors/new"
            element={
              <ProtectedRoute>
                <VendorForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendors/:id/edit"
            element={
              <ProtectedRoute>
                <VendorForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/discount-codes"
            element={
              <ProtectedRoute>
                <DiscountCodes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/discount-codes/new"
            element={
              <ProtectedRoute>
                <DiscountCodeForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/discount-codes/:id/edit"
            element={
              <ProtectedRoute>
                <DiscountCodeForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-applications"
            element={
              <ProtectedRoute>
                <NaytiveApplications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-inbox"
            element={
              <ProtectedRoute>
                <NaytiveInbox />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-banking-access"
            element={
              <ProtectedRoute>
                <NaytiveBankingAccess />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-banking-waitlist"
            element={
              <ProtectedRoute>
                <NaytiveBankingWaitlist />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-landing-leads"
            element={
              <ProtectedRoute>
                <NaytiveLandingLeads />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-blog"
            element={
              <ProtectedRoute>
                <NaytiveBlog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-careers"
            element={
              <ProtectedRoute>
                <NaytiveCareers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-incorporation"
            element={
              <ProtectedRoute>
                <NaytiveIncorporation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-compliance"
            element={
              <ProtectedRoute>
                <NaytiveCompliance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/deals"
            element={
              <ProtectedRoute>
                <Deals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/filing-templates"
            element={
              <ProtectedRoute>
                <FilingTemplates />
              </ProtectedRoute>
            }
          />
          {/* /naytive-proposals route retained but not linked from
              the sidebar — keeps any old deep links / bookmarks working.
              Day-to-day proposal management happens from the Naytive
              Apps page (PROPOSAL button per row). */}
          <Route
            path="/naytive-proposals"
            element={
              <ProtectedRoute>
                <NaytiveProposals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/voice-picker"
            element={
              <ProtectedRoute>
                <VoicePicker />
              </ProtectedRoute>
            }
          />
          <Route
            path="/naytive-applications/:kind/:id"
            element={
              <ProtectedRoute>
                <NaytiveApplicationDetail />
              </ProtectedRoute>
            }
          />
          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/intelligence/kb" element={<ProtectedRoute><IntelligenceKb /></ProtectedRoute>} />
          <Route path="/intelligence/kb/drafts/:id" element={<ProtectedRoute><IntelligenceKbDraft /></ProtectedRoute>} />
          <Route path="/intelligence/kb/rules" element={<ProtectedRoute><IntelligenceKbRules /></ProtectedRoute>} />
          <Route path="/intelligence/kb/rules/:id" element={<ProtectedRoute><IntelligenceKbRecord /></ProtectedRoute>} />
          <Route path="/intelligence/concierge" element={<ProtectedRoute><IntelligenceConcierge /></ProtectedRoute>} />
          <Route path="/intelligence/concierge/turns/:id" element={<ProtectedRoute><IntelligenceConciergeTurn /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
